import { render, staticRenderFns } from "./PricingCard.vue?vue&type=template&id=6b7e358b&scoped=true&"
import script from "./PricingCard.vue?vue&type=script&lang=js&"
export * from "./PricingCard.vue?vue&type=script&lang=js&"
import style0 from "./PricingCard.vue?vue&type=style&index=0&id=6b7e358b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7e358b",
  null
  
)

export default component.exports